import React, { useState } from 'react'
import { Help, Info } from '@mui/icons-material'
import { IconButton, Tooltip, ClickAwayListener } from '@mui/material'

const ToolTip = ({ toolTip, modal, position }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  if (toolTip) {
    return (
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            open={open}
            placement={position}
            title={toolTip}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            onClose={handleTooltipClose}
            //sx={{padding: '0px 4px'}}
          >
            <IconButton onClick={handleTooltipOpen}>
              <Help className="btn-point-events"/>
            </IconButton>
          </Tooltip>
        </div>
      </ClickAwayListener>
      
    )
  } else if (modal) {
    return (
      <IconButton
        className={toolTipClass}
        touch
        onClick={() => {
          return modal.onClick(modal.modalName)
        }}
      >
        <Info className="btn-point-events" />
      </IconButton>
    )
  }
  return null
}

const returnTag = (
  tag = 'p',
  text,
  toolTip,
  modal,
  position = 'top',
) => {
  const newTag = tag.toUpperCase()
  switch (newTag) {
    case 'H1':
      return (
        <h1 className="help-text">
          {text}
          <ToolTip
            toolTip={toolTip}
            modal={modal}
            position={position}
          />
        </h1>
      )
    case 'H2':
      return (
        <h2 className="help-text">
          {text}
          <ToolTip
            toolTip={toolTip}
            modal={modal}
            position={position}
          />
        </h2>
      )
    case 'H3':
      return (
        <h3 className="help-text">
          {text}
          <ToolTip
            toolTip={toolTip}
            modal={modal}
            position={position}
          />
        </h3>
      )
    case 'span':
      return (
        <span className="help-text">
          {text}
          <ToolTip
            toolTip={toolTip}
            modal={modal}
            position={position}
          />
        </span>
      )
    default:
      return (
        <p className="help-text">
          {text}
          <ToolTip
            toolTip={toolTip}
            modal={modal}
            position={position}
          />
        </p>
      )
  }
}

export default function({ tag, text, toolTip, modal, position, toolTipClass }) {
  return returnTag(tag, text, toolTip, modal, position, toolTipClass)
}
